import React, {useState, Suspense} from 'react';

import ErrorBoundary from "../ErrorBoundary"
import {useStores} from "../../stores/Context";
import BtnSvg from "../../boiteAOutils/BtnSvg";
import axios from "axios";
import PlanningActionsStore from "../../stores/Widgets/PlanningActionsStore";
import RspStore from "../../stores/Widgets/RspStore";
import {useParams} from "react-router-dom";

// Dynamic Import
const loadWidget = (widget) =>
    React.lazy(() => import(`./${widget}/${widget}.js`));

const Widget = ({idWidget, typeWidget}) => {
    const {ent} = useParams();
    const [WidgetComponent] = useState(loadWidget(typeWidget));
    const {uiStore, widgetStore, createWidgetStore, PlanningActionsStore, RspStore} = useStores();

    const handleClickUpdateWidget = (idWidget, typeWidget) => {
        if (typeWidget === "WidgetRSP") {
            uiStore.openConsultingModeRSP(RspStore, widgetStore.getCookie("current_apiToken"), idWidget);
        } else if (typeWidget === "WidgetPlanningActions") {
            axios.get(process.env.REACT_APP_API_URL + '/api/PA/infosWidget/' + idWidget,
                {headers: {"Authorization": `Bearer ${widgetStore.getCookie("current_apiToken")}`}}
            ).then((res) => {
                uiStore.openConsultingModePlan2do(PlanningActionsStore, widgetStore.getCookie("current_apiToken"), idWidget, res.data.idPlanning, "Paramétrage");
            });
        } else {
            uiStore.openCreationMode();
            createWidgetStore.openModificationMode(idWidget, typeWidget);
        }
    };

    return (
        <ErrorBoundary>
            <Suspense fallback={<>Loading</>}>
                {
                    uiStore.isPanelOpened && (
                        <div
                            className={`filigraneWidgetDraggable`}>
                            {
                                !uiStore.isDeleteModeWidget && (
                                    !['WidgetDateHeure', 'WidgetFacebook', 'WidgetMeteo',
                                        'WidgetMessagesInterServices', 'WidgetBibliothequeImages'].includes(typeWidget) && (
                                        <BtnSvg svg={"parametre"} height={50} width={50}
                                                onClick={() => handleClickUpdateWidget(idWidget, typeWidget)}
                                                style={{
                                                    position: "absolute",
                                                    top: "0.5em",
                                                    right: "0.7em",
                                                    zIndex: 999999
                                                }}/>
                                    )
                                )
                            }
                        </div>
                    )
                }
                <WidgetComponent idWidget={idWidget}/>
            </Suspense>
        </ErrorBoundary>
    )
};

export default Widget;